import React from 'react';
import { getDollarFormat } from 'utils/helpers';

const Body = ({ orders, reportDate }) => (
    <div>
        <div className="table-responsive">
            {
                orders && orders.length > 0 &&
                <div className="text-center pb-2 pt-2 mt-2 purpleText">
                    <h2 className="m-0 p-0">SUMMARY</h2>
                    <h4 className="mt-0 pt-0"><i>{reportDate}</i></h4>
                </div>
            }
            <div className="row m-0 col-4-p-0 col-4-em-0">
                {
                    orders.map((item, index) => {
                        return (
                            <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12" key={index}>
                                <div className="row m-0 green_box">
                                    <div className="sales_label_container"><label>{item.salesDate}</label></div>
                                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 m-0 p-0 text-center in_green_box">
                                        <div><b># of Orders</b></div>
                                        <h2 className="p-0 m-0 text-muted"><b>{item.numbersOfOrders}</b></h2>
                                    </div>
                                    <div className="col-lg-9 col-md-9 col-sm-9 col-xs-9  m-0 p-0 pt-2 text-right in_green_box">
                                        <div><b>Net Sales</b></div>
                                        <h2 className="p-0 m-0 mb-4 money">{item.totalRevenue ? getDollarFormat((item.totalRevenue || 0)) : "$0"}</h2>
                                        <span><b>Total Revenue</b></span>
                                        <h2 className="p-0 m-0 money">{(!item.totalRevenue && !item.taxes) ? "$0" : getDollarFormat((item.taxes || 0) + (item.totalRevenue || 0))}</h2>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  m-0 p-0 pt-2 text-right">
                                        <h5><i className='purpleText'>Average net sale per order: <span className="money">{item.averageOrder ? getDollarFormat((item.averageOrder || 0)) : "$0"}</span></i></h5>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    </div>
);

export default Body;